import { openSafeWindow } from '@bit/utils';
import BigNumber from 'bignumber.js';
import dayjs from 'dayjs';
import { contractInfo } from './contract';

export let isBitkeep = false;
export let isWeixinBrowser = false;
if (typeof window !== 'undefined') {
  isBitkeep = /(BitKeep)/i.test(window.navigator.userAgent);
  isWeixinBrowser = /MicroMessenger/i.test(window.navigator.userAgent);
}

// morph首次进入弹窗
export const SHOW_MORPH_KEY = 'bgbStaking_first_show_morph_v22';

export function getBuyUrl() {
  return `bitkeep://global_recharge?from=bgbStaking&chain=morph&symbol=BGB&contract=${contractInfo.address}`;
}

export function handleOpenApp() {
  const url = `https://web3.bitget.cloud/wallet-download?type=0&deep_link_value=bitkeep://webview?url=${getAppUrl(window.location.origin + window.location.pathname)}`;
  openSafeWindow(url, '_blank');
}

export function getAppUrl(url = window.location.href) {
  const u = new URL(url);
  u.searchParams.set('_nocache', 'true');
  u.searchParams.set('_nobar', 'true');
  u.searchParams.set('_needChain', 'morph');
  return u.toString();
}
function removeTrailingZeros(num: string): string {
  return num.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
}
// // 去掉前后多余的0
// function removeLeadingZerosAndTrailingZeros(numStr: string): string {
//   // 防止返回0
//   if (numStr === '') return numStr;
//   // 去除前导零，特殊处理纯零情况
//   numStr = numStr.replace(/^0+/, '') || '0'; // 如果是纯零字符串，返回 '0'
//   // 如果没有小数点，直接返回数值（已经去除了前导零）
//   if (!numStr.includes('.')) {
//     return numStr;
//   }

//   // 处理小数点部分，去除末尾多余的零
//   numStr = numStr.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');

//   // 处理 "42." 这种情况，去掉小数点
//   if (numStr.endsWith('.')) {
//     numStr = numStr.slice(0, -1); // 移除末尾的小数点
//   }

//   // 确保如果小数部分存在且没有前导零时，结果是 "0.xxxx" 格式
//   if (numStr.startsWith('.')) {
//     numStr = '0' + numStr; // 如果数字是以小数点开头，前面加上 '0'
//   }

//   return numStr;
// }

// 小数位控制
export function formatDecimalSimple(input: string, decimalPlaces = 8): string {
  if (!input) return '0';
  const regex = new RegExp(`^(\\d+)(\\.\\d{0,${decimalPlaces}})?`);
  const match = input.match(regex);
  return match ? match[0] : '';
}

// 字符串千分位
export function formatStringNumber(str: string) {
  if (!str) return '0';
  const [integer, decimal] = str.split('.'); // 拆分整数部分和小数部分
  // 格式化整数部分
  const value = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  // 如果有小数部分，保留原样；如果没有小数部分，直接返回整数部分
  return decimal ? value + '.' + decimal : value;
}
// function removeLeadingZerosAndTrailingZeros(numStr) {
//   // 如果输入为空字符串，直接返回 '0'
//   if (numStr === '') return '0';

//   // 如果是纯零情况，如 '0.00', '000', '000.00' 等，直接返回 '0'
//   if (/^0*\.?0*$/.test(numStr)) return '0';

//   // 去除前导零，特殊处理纯零情况
//   numStr = numStr.replace(/^0+/, '') || '0'; // 如果是纯零字符串，返回 '0'

//   // 如果没有小数点，直接返回数值（已经去除了前导零）
//   if (!numStr.includes('.')) {
//     return numStr;
//   }

//   // 处理小数点部分，去除末尾多余的零
//   numStr = numStr.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '');

//   // 处理 "42." 这种情况，去掉小数点
//   if (numStr.endsWith('.')) {
//     numStr = numStr.slice(0, -1); // 移除末尾的小数点
//   }

//   // 确保如果小数部分存在且没有前导零时，结果是 "0.xxxx" 格式
//   if (numStr.startsWith('.')) {
//     numStr = '0' + numStr; // 如果数字是以小数点开头，前面加上 '0'
//   }

//   return numStr;
// }
// 处理数字，限制8位小数，去掉多余0
export function formatDecimal(input: string, decimalPlaces = 8): string {
  // return removeLeadingZerosAndTrailingZeros(formatDecimalSimple(input, decimalPlaces));
  return removeTrailingZeros(formatDecimalSimple(input, decimalPlaces));
}
// 在formatDecimal上，额外处理千分服位
export function formatAmount(str: string, decimalPlaces = 8) {
  return formatStringNumber(formatDecimal(str, decimalPlaces));
}
// window.formatAmount = formatAmount;
// window.formatDecimalSimple = formatDecimalSimple;
// window.removeLeadingZerosAndTrailingZeros = removeLeadingZerosAndTrailingZeros;
export const chain = 'morph';

export function getYearRate() {
  // return BigNumber(data.reward_cap || 0)
  //   .dividedBy(data.stake_cap || 0)
  //   .multipliedBy(365)
  //   .dividedBy(data.duration)
  //   .multipliedBy(100)
  //   .toFixed(1, BigNumber.ROUND_HALF_UP);
  // 都用5%年化
  return '5';
}

export function formatDate(date: Date | string | number): string {
  // 使用 dayjs 格式化日期
  return dayjs(date).format('YYYY-M-D HH:mm:ss');
}
// 秒转换天
export function secondsTurnDay(duration: string | number) {
  return BigNumber(Number(duration) / 86400)
    .dp(2)
    .toString();
}
